import type { BaseSlideProps, ConceptPairContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function ConceptPairSlide({ title, content, accentColor }: BaseSlideProps) {
  const { conceptA, conceptB } = content as ConceptPairContent;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-4xl font-serif font-bold mb-8 text-center accent-text">
        {title}
      </h2>

      <div className="split-layout">
        {/* Concept A */}
        <div className="concept-card">
          <div className="concept-label">{conceptA.label}</div>
          <p className="text-slate-700 dark:text-slate-300 mb-4 leading-relaxed"
             dangerouslySetInnerHTML={{ __html: inlineMarkdown(conceptA.description) }} />

          {conceptA.examples && conceptA.examples.length > 0 && (
            <div className="mt-4 space-y-2">
              <p className="text-sm font-medium text-slate-600 dark:text-slate-400">
                Examples:
              </p>
              <ul className="space-y-2">
                {conceptA.examples.map((example, idx) => (
                  <li key={idx} className="text-sm text-slate-600 dark:text-slate-400 flex">
                    <span className="accent-text mr-2">•</span>
                    <span dangerouslySetInnerHTML={{ __html: inlineMarkdown(example) }} />
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Concept B */}
        <div className="concept-card">
          <div className="concept-label">{conceptB.label}</div>
          <p className="text-slate-700 dark:text-slate-300 mb-4 leading-relaxed"
             dangerouslySetInnerHTML={{ __html: inlineMarkdown(conceptB.description) }} />

          {conceptB.examples && conceptB.examples.length > 0 && (
            <div className="mt-4 space-y-2">
              <p className="text-sm font-medium text-slate-600 dark:text-slate-400">
                Examples:
              </p>
              <ul className="space-y-2">
                {conceptB.examples.map((example, idx) => (
                  <li key={idx} className="text-sm text-slate-600 dark:text-slate-400 flex">
                    <span className="accent-text mr-2">•</span>
                    <span dangerouslySetInnerHTML={{ __html: inlineMarkdown(example) }} />
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
